<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5 class="pull-left">
                Meetings
            </h5>

            <div class="pull-right" style="margin-top: 8px">
                <button type="button" class="btn btn-xs btn-white" @click="navigate(-1)">
                    <i class="fa fa-chevron-left"/>
                </button>

                {{ date.format('WW/GGGG') }}

                <button type="button" class="btn btn-xs btn-white" @click="navigate(1)">
                    <i class="fa fa-chevron-right"/>
                </button>
            </div>

            <div class="clearfix"/>
        </div>

        <loading-spinner v-if="loading"/>

        <ul v-else class="list-group">
            <li v-for="(row, index) in data" class="list-group-item">
                <div style="display: flex; align-items: center;">
                    <div style="font-size: 40px; line-height: 1; margin-right: 15px;" :style="index === 0 ? 'color: #FFD700' : ''">
                        {{ index + 1 }}.
                    </div>

                    <div style="flex-basis: 0; flex-grow: 1">
                        {{ row.user_full_name }}
                    </div>

                    <div style="flex-basis: 0; flex-grow: 1; text-align: center;">
                        <span style="font-size: 20px; line-height: 1">
                            {{ row.created_count }}
                        </span>

                        <br>

                        <span style="color: #aaaaaa; font-size: 12px">
                            Created
                        </span>
                    </div>

                    <div style="flex-basis: 0; flex-grow: 1; text-align: center;">
                        <span style="font-size: 20px; line-height: 1">
                            {{ row.held_count}}/{{ row.starts_count }}
                        </span>

                        <br>

                        <span style="color: #aaaaaa; font-size: 12px">
                            Held
                        </span>
                    </div>
                </div>
            </li>


            <li v-if="!data.length" class="list-group-item text-center">
                <i>
                    No meetings have been registered for this week.
                </i>
            </li>
        </ul>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {LoadingSpinner},

        data() {
            return {
                data: null,

                date: moment(),

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        methods: {
            load() {
                http.post('/api/v1/reports/meetings', {
                    start: this.date.startOf('isoweek').format('YYYY-MM-DD'),
                    end: this.date.endOf('isoweek').format('YYYY-MM-DD')
                })
                    .then(response => {
                        this.data = response.data.data

                        this.loading = false
                    })
            },

            navigate(step) {
                this.date = this.date.add(step, 'week')

                this.load()
            }
        }
    }
</script>
